import React, { useState, useEffect } from 'react';

const JsonEditor = ({ value, onChange, height = '200px' }) => {
  const [jsonString, setJsonString] = useState('');
  const [error, setError] = useState(null);

  // Convert JSON object to string when value changes
  useEffect(() => {
    try {
      const formatted = JSON.stringify(value, null, 2);
      setJsonString(formatted);
      setError(null);
    } catch (err) {
      console.error('Error stringifying JSON:', err);
      setError('Invalid JSON object');
    }
  }, [value]);

  // Handle text change in the editor
  const handleChange = e => {
    const newValue = e.target.value;
    setJsonString(newValue);

    try {
      // Only update parent if valid JSON
      const parsedJson = JSON.parse(newValue);
      onChange(parsedJson);
      setError(null);
    } catch (err) {
      // Keep the text in the editor but show error
      setError('Invalid JSON: ' + err.message);
    }
  };

  return (
    <div className="w-full">
      <textarea
        value={jsonString}
        onChange={handleChange}
        className={`w-full font-mono text-sm border ${error ? 'border-red-300' : 'border-gray-300'} rounded p-2`}
        style={{ height, resize: 'vertical' }}
        spellCheck="false"
        placeholder="Enter JSON here..."
      />
      {error && <p className="mt-1 text-red-500 text-xs">{error}</p>}
    </div>
  );
};

export default JsonEditor;
